import { FC, useEffect, useState } from 'react'
import GlobalSpinner from '../globalsSpinner/GlobalSpinner';
import { FormInputNumber, FormRowHorizontal } from '../formRow/FormRow';
import { Button } from '../Button';
import { AdvertisingInfo, ReachTrackerInfo, getAdvertisingInfo, getReachTrackerInfo, patchAdvertisingInfo, patchReachTrackerInfo } from '../../../api/playersApi';
import { useParams } from 'react-router-dom';

const ReachTracker:FC = () => {
    let [isLoading, setIsLoading] = useState(false)
    let [monday, setMonday] = useState<number | ''>('')
    let [isMondayError, setIsMondayError] = useState(false)
    let [tuesday, setTuesday] = useState<number | ''>('')
    let [isTuesdayError, setIsTuesdayError] = useState(false)
    let [wednesday, setWednesday] = useState<number | ''>('')
    let [isWednesdayError, setIsWednesdayError] = useState(false)
    let [thursday, setThursday] = useState<number | ''>('')
    let [isThursdayError, setIsThursdayError] = useState(false)
    let [friday, setFriday] = useState<number | ''>('')
    let [isFridayError, setIsFridayError] = useState(false)
    let [saturday, setSaturday] = useState<number | ''>('')
    let [isSaturdayError, setIsSaturdayError] = useState(false)
    let [sunday, setSunday] = useState<number | ''>('')
    let [isSundayError, setIsSundayError] = useState(false)


    let {id : playerId} = useParams<{id:string}>();

    useEffect(() => {
        async function fetchData(){
            setIsLoading(true);
            await updateReachTrackerInfo()
            setIsLoading(false);
        }

        fetchData()
    }, [])

    const isDurationValid = (value: number | '') => {
        if (value === '') return false;
        
        return value >= 0;
    };

    const updateReachTrackerInfo = async () => {
        let result = await getReachTrackerInfo(playerId)
        if (result.type == "succes") {
            setMonday(result.data.data.monday)
            setTuesday(result.data.data.tuesday)
            setWednesday(result.data.data.wednesday)
            setThursday(result.data.data.thursday)
            setFriday(result.data.data.friday)
            setSaturday(result.data.data.saturday)
            setSunday(result.data.data.sunday)
        }
    }

    const saveReachTrackerInfo = async () => {
        let isValid = true;

        if(!isDurationValid(monday)){
            setIsMondayError(true);
            isValid = false;
        }
        if(!isDurationValid(tuesday)){
            setIsTuesdayError(true);
            isValid = false;
        }
        if(!isDurationValid(wednesday)){
            setIsWednesdayError(true);
            isValid = false;
        }
        if(!isDurationValid(thursday)){
            setIsThursdayError(true);
            isValid = false;
        }
        if(!isDurationValid(friday)){
            setIsFridayError(true);
            isValid = false;
        }
        if(!isDurationValid(saturday)){
            setIsSaturdayError(true);
            isValid = false;
        }
        if(!isDurationValid(sunday)){
            setIsSundayError(true);
            isValid = false;
        }

        if(!isValid) return;

        let request: ReachTrackerInfo = {
            monday: +monday,
            tuesday: +tuesday,
            wednesday: +wednesday,
            thursday: +thursday,
            friday: +friday,
            saturday: +saturday,
            sunday: +sunday
        }

        setIsLoading(true)
        await patchReachTrackerInfo(playerId, request);
        await updateReachTrackerInfo()
        setIsLoading(false)
    }

    return <>
        <div className="advertising-block" style={{width:500}}>
            <FormRowHorizontal>
                <FormInputNumber
                    id="monday-duration"
                    title="Monday Duration"
                    isError={isMondayError}
                    errorMessage="Duration should be more than 0"
                    value={monday}
                    onChange={e => {
                        setIsMondayError(false)
                        e.target.value === '' ? setMonday(0) : setMonday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="tuesday-duaration"
                    title="Tuesday Duration"
                    isError={isTuesdayError}
                    errorMessage="Duration should be more than 0"
                    value={tuesday}
                    onChange={e => {
                        setIsTuesdayError(false)
                        e.target.value === '' ? setTuesday(0) : setTuesday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="wednesday-duaration"
                    title="Wednesday Duration"
                    isError={isWednesdayError}
                    errorMessage="Duration should be more than 0"
                    value={wednesday}
                    onChange={e => {
                        setIsWednesdayError(false)
                        e.target.value === '' ? setWednesday(0) : setWednesday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="thursday-duaration"
                    title="Thursday Duration"
                    isError={isThursdayError}
                    errorMessage="Duration should be more than 0"
                    value={thursday}
                    onChange={e => {
                        setIsThursdayError(false)
                        e.target.value === '' ? setThursday(0) : setThursday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="friday-duaration"
                    title="Friday Duration"
                    isError={isFridayError}
                    errorMessage="Duration should be more than 0"
                    value={friday}
                    onChange={e => {
                        setIsFridayError(false)
                        e.target.value === '' ? setFriday(0) : setFriday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="saturday-duaration"
                    title="Saturday Duration"
                    isError={isSaturdayError}
                    errorMessage="Duration should be more than 0"
                    value={saturday}
                    onChange={e => {
                        setIsSaturdayError(false)
                        e.target.value === '' ? setSaturday(0) : setSaturday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="sunday-duaration"
                    title="Sunday Duration"
                    isError={isSaturdayError}
                    errorMessage="Duration should be more than 0"
                    value={sunday}
                    onChange={e => {
                        setIsSundayError(false)
                        e.target.value === '' ? setSunday(0) : setSunday(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <div className="form-btn">
                <Button color="green" label="Save" onClick={saveReachTrackerInfo} />
            </div>
        </div>
        <GlobalSpinner isShow={isLoading} />
    </>
}

export default ReachTracker